<template>
  <div>
  <ConfirmModal
    v-model="isModalVisible"  
    @confirm=confirmModal
    @cancel=closeModal
    :is-modal-working="isModalWorking"
  >
    <template v-slot:title>Reassign Device </template>
    <template v-slot:confirm>Reassign</template>
    <template v-slot:cancel>Cancel</template>
    <p>Select the individual to reassign this device to. </p>
    <p><b>Note:</b> The user still has to accept receipt of the device before liability is transferred.</p>
    <table v-if="device" class="ui table">
        <thead>
          <tr>
            <th>Model</th>
            <th>Serial</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          <td>{{device.model.name}}</td>
          <td>{{device.serial}}</td>
          </tr>
        </tbody>
      </table>
    <div class="ui left icon input" :class="isTargetValid ? '' : 'error'" >
      <datalist id="suggestions">
          <option v-for="user in users" :key="user.email">{{ user.name }}</option>
      </datalist>
        <input v-model="reassignTarget" autoComplete="on" list="suggestions" placeholder="Search users..."/> 
        <i class="users icon"></i>
    </div>
    <!-- Error Message -->
    <span v-if="!isAttemptValid" id="error-message" class="ui red text">{{ errorMessage }}</span>
    <!-- Loading Message -->
    <span v-if="isAttemptValid && isModalWorking" id="loading-message" class="ui active inline loader"></span>

  </ConfirmModal>
  </div>
</template>

<script>
import axios from 'axios';
import sampleConfig from '../config';
import ConfirmModal from './ConfirmModal.vue';


// TODO: emit an event to the parent for success or failure or potentially emit the original event from base modal. This should contain the info on success to remove the device from
// the users list of devices.
export default {
  name: 'ReassignAssetModal',
  emits: ['success', 'failure'],
  data() {
    return {
      isModalVisible: false,
      users: [],
      reassignTarget: null,
      device: null,
      isTargetValid: true,
      isAttemptValid: true,
      errorMessage: '',
      isModalWorking: false
    }
  },
  watch: {
    reassignTarget(value){
      this.validateTarget(value);
    }
  },
    methods: {
    // userSearch
    showModal(device, users) {
      this.users = users;
      this.device = device; 
      this.isModalVisible = true;
    },
    closeModal() {
      this.reassignTarget = null;
      this.isModalVisible = false;
    },
    async confirmModal() {
      try {
        this.isModalWorking = true;
        let attempt = await this.reassignAsset(this.device, this.reassignTarget);
        if (!attempt) {
          this.errorMessage = "Please enter a valid user!"
          this.isAttemptValid = false;
          this.isModalWorking = false;
          // emit event for failure 
          this.$emit('failure', this.device.serial)
          return;
        }
        // Emit event for success
        this.$emit('success', this.device.serial)
        this.isModalWorking = false;
        this.isModalVisible = false;
        this.reassignTarget = null;
      } catch (e) {
        this.isAttemptValid = false;
        console.error(e);
        this.errorMessage = `An error occurred: ${e}`;
        this.isModalWorking = false;
      }
    },
    validateTarget(reassignTarget){
      // Case insensitive comparison
      let targetUser = this.users.find(user => user.name.localeCompare(reassignTarget, undefined, { sensitivity: 'base' }) === 0);
      if (!targetUser) {
        this.isTargetValid = false;
        return null;
      }
      this.isTargetValid = true;
      return targetUser
    },
    // TODO: Important to catch axios errors when they occur and fail nicely. Instead of VUE showing the uncaught exceptions.
    async reassignAsset(device, reassignTarget){
      let targetUser = this.validateTarget(reassignTarget);
      if (!this.isTargetValid) {
        return null;
      }
      const response = await axios.post(
        sampleConfig.resourceServer.reassignUrl.replace('<asset_id>', device.id),
        {
          rec_user: {
            id: targetUser.id,
            name: targetUser.name
          }
        },
        {
          headers: {Authorization: `Bearer ${this.$auth.getAccessToken()}`}
        }
      )
      return response;
    }
  },
  components: {
    ConfirmModal
  },
  inheritAttrs: false,
}
</script>
<style>
  #error-message, #loading-message {
    margin-left: 1em;
  }
</style>